(() => {
  if (customElements.get('ambreux-tryon')) return;
  customElements.define('ambreux-tryon', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.words = JSON.parse(this.dataset.words);
      this.variants = JSON.parse(this.dataset.variants).map(variant => ({...variant, featured_image: variant.featured_image || (this.dataset.productImage ? {src:this.dataset.productImage} : null)}));
      this.openButton = this.querySelector('[data-open]');
      this.openButton.addEventListener('click', () => this.open());
      if (this.closest('.abx-editorial-product__media')) {
        const startIntro = () => {
          this.classList.add('at-intro-active');
          this.introTimer = setTimeout(() => this.classList.remove('at-intro-active'), 3500);
        };
        if ('IntersectionObserver' in window) {
          this.introObserver = new IntersectionObserver(entries => {
            if (!entries.some(entry => entry.isIntersecting)) return;
            this.introObserver.disconnect();
            startIntro();
          }, { threshold: 0.5 });
          this.introObserver.observe(this);
        } else startIntro();
      }
    }
    disconnectedCallback() { clearTimeout(this.introTimer); this.introObserver?.disconnect(); this.close(); }
    release(name) { if (this[name]) URL.revokeObjectURL(this[name]); this[name] = null; }
    close() {
      this.consented = false;
      this.stopGenerationAnimation();
      this.nativeObserver?.disconnect(); clearTimeout(this.variantTimer);
      this.controller?.abort(); this.lifecycle?.abort(); this.stopCamera(); this.photoVersion = (this.photoVersion || 0) + 1;
      if (this.dialog) { this.dialog.close(); this.dialog.remove(); this.dialog = null; }
      this.release('photoUrl'); this.release('resultUrl'); this.photo = null; this.busy = false;
      this.resultBlob = null; this.shareBusy = false;
      if (this.isConnected) this.openButton?.focus();
    }
    open() {
      if (this.dialog) return;
      const selected = document.getElementById(this.dataset.form)?.querySelector('[name="id"]')?.value || this.dataset.variant;
      this.variant = this.variants.find(v => String(v.id) === selected);
      const template = this.querySelector('template');
      document.body.append(template.content.cloneNode(true));
      this.dialog = document.body.lastElementChild;
      const find = selector => this.dialog.querySelector(selector);
      this.status = find('[data-status]'); this.generateButton = find('[data-generate]');
      this.backButton = find('[data-back]'); this.backButton.addEventListener('click', () => this.goBack());
      this.tipsScreen = find('[data-tips]'); this.pictureScreen = find('[data-picture-mode]'); this.step = 'tips';
      find('[data-tips-start]').addEventListener('click', () => this.showStep('picture'));
      this.pictureCamera = find('[data-picture-camera]'); this.pictureUpload = find('[data-picture-upload]');
      this.pictureCamera.addEventListener('click', () => this.startCamera());
      this.pictureUpload.addEventListener('click', () => { if (this.credits?.remaining > 0 && !this.busy) this.upload.click(); });
      this.creditStatus = find('[data-credit-status]'); this.creditRetry = find('[data-credit-retry]'); this.creditNote = find('[data-credit-note]');
      this.creditRetry.addEventListener('click', () => this.checkCredits());
      this.credits = null; this.creditsLoading = false; this.creditsError = false; this.creditExhausted = false;
      this.upload = find('[data-upload]'); this.uploadZone = find('[data-upload-zone]');
      this.generationOverlay = find('[data-generation]'); this.generationTime = find('[data-generation-time]');
      this.generationPhoto = find('[data-generation-photo]');
      this.cameraButton = find('[data-camera-open]'); this.cameraPanel = find('[data-camera]');
      this.photoActions = find('[data-photo-actions]'); this.changePhotoButton = find('[data-change-photo]');
      this.changePhotoButton.addEventListener('click', () => {
        if (!this.busy && !this.creditExhausted && this.credits?.remaining > 0) this.upload.click();
      });
      this.video = find('[data-video]'); this.cameraStatus = find('[data-camera-status]'); this.countdown = find('[data-countdown]');
      this.captureButton = find('[data-camera-capture]'); this.captureButton.addEventListener('click', () => this.beginCaptureCountdown());
      this.lifecycle = new AbortController();
      this.consented = false;
      find('[data-policy-cancel]').addEventListener('click', () => this.close());
      find('[data-policy-continue]').addEventListener('click', () => this.continueToFittingRoom());
      find('[data-review-policies]').addEventListener('click', () => this.reviewPolicies());
      const adminForm = find('[data-admin-form]');
      adminForm?.addEventListener('submit', event => {event.preventDefault();this.saveMetaKey(adminForm);});
      this.cameraButton.addEventListener('click', () => this.startCamera());
      find('[data-camera-cancel]').addEventListener('click', () => this.stopCamera());
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.stopCamera(); }, {signal:this.lifecycle.signal});
      window.addEventListener('pagehide', () => this.stopCamera(), {signal:this.lifecycle.signal});
      this.preview = find('[data-preview]'); this.output = find('[data-output]'); this.download = find('[data-download]');
      this.shareButton = find('[data-share-result]'); this.shareButton.addEventListener('click', () => this.shareResult());
      this.buyButton = find('[data-buy-result]'); this.purchaseStatus = find('[data-purchase-status]');
      this.resultVariant = null; this.purchaseStarted = false;
      this.resultPrice = find('[data-result-price]');
      find('[data-result-camera]').addEventListener('click', () => { if (this.credits?.remaining > 0) { this.status.textContent = ''; this.showStep('picture'); } });
      this.dialog.querySelectorAll('[data-tryon-variant]').forEach(button => button.addEventListener('click', () => this.selectTryonVariant(button.dataset.tryonVariant)));
      this.buyButton.addEventListener('click', () => this.buyResult());
      find('[data-choice]').textContent = this.variant?.title || '';
      const productImage = find('[data-product]');
      if (this.variant?.featured_image?.src) { productImage.src = this.variant.featured_image.src; productImage.hidden = false; }
      this.empty = find('[data-empty]'); this.change = find('[data-change]'); this.result = find('[data-result]');
      find('[data-close]').addEventListener('click', () => this.close());
      this.dialog.addEventListener('cancel', e => { e.preventDefault(); this.close(); });
      this.dialog.addEventListener('click', e => { if (e.target === this.dialog) this.close(); });
      this.upload.addEventListener('change', () => this.selectPhoto());
      this.generateButton.addEventListener('click', () => this.generate());
      this.dialog.showModal();
      this.ready = false; this.busy = false; this.update();
      const productInfo = document.getElementById(this.dataset.form)?.closest('product-info');
      if (productInfo && 'MutationObserver' in window) {
        this.nativeObserver = new MutationObserver(() => this.syncNativeProduct());
        this.nativeObserver.observe(productInfo, {subtree:true,childList:true,attributes:true,attributeFilter:['disabled','class']});
      }
      document.getElementById(this.dataset.form)?.addEventListener('change', () => this.syncNativeProduct(), {signal:this.lifecycle.signal});
      this.syncNativeProduct();
    }
    continueToFittingRoom() {
      if (!this.dialog || this.consented) return;
      this.consented = true;
      this.dialog.querySelector('[data-policies]').hidden = true;
      this.dialog.querySelector('[data-fitting-room]').hidden = false;
      this.dialog.classList.remove('at-policy-mode');
      this.dialog.setAttribute('aria-label', this.dialog.dataset.fittingTitle);
      this.dialog.scrollTop = 0;
      this.showStep('tips');
      if (!this.variant?.featured_image?.src) { this.status.textContent = this.words.reference; return; }
      this.checkHealth();
      this.checkCredits();
    }
    showStep(step) {
      if (!this.dialog) return;
      this.step = step; this.update(); this.dialog.scrollTop = 0;
      this.dialog.querySelector(`[data-step-title="${step}"]`)?.focus();
    }
    goBack() {
      if (!this.dialog || !this.consented || this.busy) return;
      if (this.step === 'tips') this.reviewPolicies();
      else if (this.step === 'picture') this.showStep('tips');
      else if (this.step === 'camera') this.stopCamera();
      else if (this.step === 'review') this.showStep('picture');
    }
    reviewPolicies() {
      if (!this.dialog || this.busy) return;
      this.consented = false;
      this.stopCamera();
      this.dialog.querySelector('[data-fitting-room]').hidden = true;
      this.dialog.querySelector('[data-policies]').hidden = false;
      this.dialog.classList.add('at-policy-mode');
      this.dialog.setAttribute('aria-label', this.dialog.querySelector('[data-policy-title]').textContent);
      this.dialog.querySelector('[data-close]').focus();
    }
    async saveMetaKey(form) {
      const dialog=this.dialog, button=form.querySelector('[data-admin-save]');
      if(button.disabled)return;
      const words=JSON.parse(form.dataset.adminWords), message=form.querySelector('[data-admin-status]');
      const password=form.querySelector('[data-admin-password]'), token=form.querySelector('[data-admin-token]');
      const authorization=password.value.trim(), apiKey=token.value.trim();
      password.value='';token.value='';button.disabled=true;message.textContent=words.saving;
      try {
        const endpoint=new URL(this.dataset.endpoint);
        if(endpoint.protocol!=='https:')throw new Error('failed');
        const response=await fetch(new URL('/admin/api/key',endpoint),{
          method:'POST',headers:{Authorization:'Bearer '+authorization,'Content-Type':'application/json'},
          body:JSON.stringify({apiKey}),credentials:'omit',
          signal:AbortSignal.any([this.lifecycle.signal,AbortSignal.timeout(25000)])
        });
        const result=await response.json().catch(()=>({}));
        if(!response.ok||result.saved!==true)throw new Error(response.status===404?'unpublished':result.error==='unauthorized'?'unauthorized':result.error==='key_validation_failed'?'invalid':result.error==='key_not_editable'?'key_locked':'failed');
        if(this.dialog!==dialog)return;
        message.textContent=words.saved;await this.checkHealth();
      } catch(error) {if(this.dialog===dialog)message.textContent=words[error.message]||words.failed;}
      finally {if(this.dialog===dialog)button.disabled=false;}
    }
    async checkHealth() {
      const dialog = this.dialog;
      let themeKeySetup=false;
      try {
        const endpoint = new URL(this.dataset.endpoint);
        if (endpoint.protocol !== 'https:') throw new Error();
        const response = await fetch(new URL('/health',endpoint), {signal:AbortSignal.timeout(10000),credentials:'omit'});
        const health = await response.json();
        if (this.dialog !== dialog) return;
        this.ready = response.ok && health.ready === true;
        themeKeySetup=response.ok && health.themeKeySetup===true;
      } catch { if (this.dialog === dialog) this.ready = false; }
      if (this.dialog !== dialog) return;
      const adminForm=dialog.querySelector('[data-admin-form]');
      if(adminForm){
        adminForm.querySelector('[data-admin-save]').disabled=!themeKeySetup;
        if(!themeKeySetup)adminForm.querySelector('[data-admin-status]').textContent=JSON.parse(adminForm.dataset.adminWords).unpublished;
      }
      this.status.textContent = this.ready ? '' : this.words.unavailable;
      this.update();
    }
    getVisitorId() {
      if (this.visitorId) return this.visitorId;
      try {
        const stored = localStorage.getItem('ambreux_tryon_visitor');
        this.visitorId = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i.test(stored || '') ? stored : crypto.randomUUID();
        localStorage.setItem('ambreux_tryon_visitor', this.visitorId);
      } catch { this.visitorId ||= crypto.randomUUID(); }
      return this.visitorId;
    }
    async checkCredits() {
      if (!this.dialog || !this.consented) return;
      const dialog = this.dialog, run = this.creditRun = (this.creditRun || 0) + 1;
      this.credits = null; this.creditsLoading = true; this.creditsError = false; this.update();
      try {
        const endpoint = new URL('/credits', this.dataset.endpoint);
        if (endpoint.protocol !== 'https:') throw new Error();
        endpoint.searchParams.set('visitorId', this.getVisitorId());
        endpoint.searchParams.set('handle', this.dataset.handle);
        const response = await fetch(endpoint, {
          credentials: 'omit', cache: 'no-store',
          signal: AbortSignal.any([this.lifecycle.signal, AbortSignal.timeout(10000)])
        });
        const credits = await response.json();
        const hasTotal = credits.totalLimit !== undefined || credits.totalUsed !== undefined;
        const validTotal = !hasTotal || (Number.isInteger(credits.totalLimit) && credits.totalLimit >= 0 &&
          Number.isInteger(credits.totalUsed) && credits.totalUsed >= 0);
        const expectedRemaining = Math.min(Math.max(0, credits.limit - credits.used),
          hasTotal ? Math.max(0, credits.totalLimit - credits.totalUsed) : Infinity);
        if (!response.ok || !Number.isInteger(credits.limit) || credits.limit < 0 ||
            !Number.isInteger(credits.used) || credits.used < 0 || !validTotal ||
            !Number.isInteger(credits.remaining) || credits.remaining !== expectedRemaining ||
            String(credits.productId) !== this.dataset.productId) throw new Error();
        if (this.dialog !== dialog || this.creditRun !== run) return;
        this.credits = credits;
        this.creditExhausted = credits.remaining === 0;
        if (this.creditExhausted && this.cameraActive) this.stopCamera();
      } catch {
        if (this.dialog !== dialog || this.creditRun !== run) return;
        this.creditsError = true;
      } finally {
        if (this.dialog === dialog && this.creditRun === run) { this.creditsLoading = false; this.update(); }
      }
    }
    update() {
      if (!this.dialog) return;
      const exhausted = this.creditExhausted || this.credits?.remaining === 0;
      const phase = this.step || (this.resultVariant ? 'result' : 'review');
      this.generateButton.disabled = !this.consented || !this.ready || !this.photo || this.cameraActive || this.busy || !this.credits || this.credits.remaining < 1 || this.creditsLoading || Boolean(this.pendingVariant);
      if (this.creditStatus) {
        this.creditStatus.textContent = this.creditsLoading ? this.words.credits_loading :
          this.creditsError ? this.words.credits_error : exhausted ? this.words.credits_exhausted : '';
        this.creditStatus.dataset.empty = String(exhausted);
        this.creditStatus.parentElement.hidden = !this.creditsLoading && !this.creditsError && !exhausted;
        this.creditRetry.hidden = !this.creditsError;
        this.creditRetry.disabled = this.busy || this.creditsLoading;
        if (this.creditNote) { this.creditNote.textContent = ''; this.creditNote.hidden = true; }
      }
      this.upload.disabled = !this.consented || this.busy || this.cameraActive || exhausted || !this.credits;
      this.cameraButton.disabled = !this.consented || this.busy || this.cameraActive || exhausted || !this.credits;
      this.dialog.querySelector('[data-review-policies]').disabled = this.busy;
      (this.cameraButton.querySelector?.('[data-camera-label]') || this.cameraButton).textContent = this.photo ? this.words.retake : this.words.camera;
      this.generateButton.textContent = this.busy ? this.words.generating : this.resultVariant && this.resultVariant !== String(this.variant?.id) ? this.words.try_colour.replace('{variant}', this.variant?.title || '') : this.words.generate;
      this.dialog.setAttribute('aria-busy',String(this.busy));
      const hasResult = Boolean(this.resultVariant && (!this.variant?.id || String(this.variant.id) === this.resultVariant));
      this.dialog.classList?.toggle?.('at-has-photo', Boolean(this.photo));
      this.dialog.classList?.toggle?.('at-has-result', hasResult);
      if (this.uploadZone) this.uploadZone.hidden = this.cameraActive || this.busy || hasResult || phase !== 'review';
      this.cameraButton.hidden = this.cameraActive || this.busy || hasResult;
      if (this.photoActions) this.photoActions.hidden = this.cameraActive || this.busy || phase !== 'review';
      if (this.changePhotoButton) {
        this.changePhotoButton.hidden = !this.photo || this.cameraActive || this.busy;
        this.changePhotoButton.disabled = !this.consented || this.busy || exhausted || !this.credits;
      }
      this.generateButton.hidden = hasResult || !['review','result'].includes(phase);
      if (this.tipsScreen) this.tipsScreen.hidden = phase !== 'tips';
      if (this.pictureScreen) this.pictureScreen.hidden = phase !== 'picture';
      if (this.pictureCamera) this.pictureCamera.disabled = !this.consented || this.busy || !this.credits || exhausted;
      if (this.pictureUpload) this.pictureUpload.disabled = !this.consented || this.busy || !this.credits || exhausted;
      if (this.captureButton) this.captureButton.disabled = !this.cameraReady || this.capturing || exhausted;
      if (this.result) this.result.hidden = !this.resultVariant || phase !== 'result';
      if (this.output) this.output.hidden = !hasResult;
      const sourcePhoto = this.dialog.querySelector('[data-result-original]');
      if (sourcePhoto) { sourcePhoto.hidden = hasResult || !this.photoUrl; if (this.photoUrl) sourcePhoto.src = this.photoUrl; }
      if (this.download) this.download.hidden = !hasResult;
      if (this.buyButton) this.buyButton.hidden = !hasResult;
      if (this.shareButton) {
        this.shareButton.hidden = !hasResult;
        this.shareButton.disabled = !hasResult || !this.resultBlob || this.busy || this.shareBusy || Boolean(this.pendingVariant);
      }
      if (this.backButton) { this.backButton.hidden = !this.consented || phase === 'result'; this.backButton.disabled = this.busy; }
      this.dialog.querySelector('[data-result-missing]')?.toggleAttribute?.('hidden', hasResult);
      this.dialog.querySelector('[data-review-policies]').hidden = ['review','result'].includes(phase);
      this.dialog.setAttribute('data-step', phase);
      this.dialog.querySelector('[data-result-camera]')?.toggleAttribute?.('disabled', exhausted || this.busy);
      if (this.resultVariant) this.updateResultPurchase();
    }
    async selectPhoto(file = this.upload.files[0]) {
      if (!this.consented || !file || this.busy || this.creditExhausted || !this.credits || this.credits.remaining < 1) return;
      this.stopCamera();
      const version = this.photoVersion = (this.photoVersion || 0) + 1;
      this.photo = null; this.release('photoUrl'); this.release('resultUrl');
      this.resultBlob = null;
      this.resultVariant = null;
      this.empty.hidden = false; this.change.hidden = true; this.result.hidden = true;
      this.preview.hidden = true; this.output.hidden = true; this.download.hidden = true; this.update();
      if (!['image/jpeg','image/png','image/webp'].includes(file.type) || file.size > 12*1024*1024) { this.status.textContent = this.words.invalid; return; }
      let bitmap;
      try {
        bitmap = await createImageBitmap(file);
        if (bitmap.width < 256 || bitmap.height < 256 || bitmap.width * bitmap.height > 50000000) throw new Error();
        // The visible review is the same centred square sent to the provider.
        // Crop uniformly; never squeeze a portrait or enlarge a small upload.
        const cropSide = Math.min(bitmap.width,bitmap.height);
        const canvas = document.createElement('canvas'); canvas.width = canvas.height = Math.min(896,cropSide);
        canvas.getContext('2d').drawImage(bitmap,(bitmap.width-cropSide)/2,(bitmap.height-cropSide)/2,cropSide,cropSide,0,0,canvas.width,canvas.height);
        const blob = await new Promise(resolve => canvas.toBlob(resolve,'image/jpeg',0.85));
        if (!blob || blob.size > 6*1024*1024) throw new Error();
        if (!this.dialog || version !== this.photoVersion) return;
        this.photo = blob; this.photoUrl = URL.createObjectURL(blob); this.preview.src = this.photoUrl; this.preview.hidden = false; this.empty.hidden = true; this.change.hidden = false;
        this.step = 'review';
        this.status.textContent = this.ready ? '' : this.words.unavailable;
      } catch { if (this.dialog && version === this.photoVersion) this.status.textContent = this.words.invalid; }
      finally { bitmap?.close(); this.update(); }
    }
    stopCamera() {
      this.cameraRun = (this.cameraRun || 0) + 1;
      clearInterval(this.cameraTimer); clearTimeout(this.cameraPlayTimer);
      this.stream?.getTracks().forEach(track => track.stop()); this.stream = null;
      if (this.video) { this.video.pause(); this.video.srcObject = null; }
      if (this.cameraPanel) { this.cameraPanel.hidden = true; this.cameraPanel.classList.remove('is-counting'); }
      if (this.uploadZone) this.uploadZone.hidden = false;
      this.cameraActive = false; this.cameraReady = false; this.capturing = false; this.update();
      if (this.step === 'camera') this.showStep(this.photo ? 'review' : 'picture');
    }
    async startCamera() {
      if (!this.consented || this.busy || this.cameraActive || this.creditExhausted || !this.credits || this.credits.remaining < 1) return;
      this.stopCamera();
      this.photoVersion = (this.photoVersion || 0) + 1;
      const run = this.cameraRun; const dialog = this.dialog;
      this.cameraActive = true; this.cameraPanel.hidden = false; this.uploadZone.hidden = true;
      this.step = 'camera'; this.cameraReady = false;
      this.dialog.scrollTop = 0;
      this.countdown.textContent = ''; this.cameraStatus.textContent = this.words.camera_starting; this.update();
      try {
        if (!navigator.mediaDevices?.getUserMedia) throw new Error('camera');
        const stream = await navigator.mediaDevices.getUserMedia({audio:false,video:{facingMode:'user',width:{ideal:1280},height:{ideal:1600}}});
        if (this.cameraRun !== run || this.dialog !== dialog) { stream.getTracks().forEach(track => track.stop()); return; }
        this.stream = stream; this.video.srcObject = stream;
        stream.getVideoTracks().forEach(track => track.addEventListener('ended', () => {
          if (this.cameraRun === run) { this.stopCamera(); if (this.dialog === dialog) this.status.textContent = this.words.camera_failed; }
        }, {once:true}));
        await Promise.race([this.video.play(), new Promise((_,reject) => { this.cameraPlayTimer = setTimeout(() => reject(new Error('camera')),10000); })]);
        if (this.cameraRun !== run || this.dialog !== dialog) return;
        clearTimeout(this.cameraPlayTimer);
        if (!this.video.videoWidth || !this.video.videoHeight) throw new Error('camera');
        this.cameraReady = true; this.cameraStatus.textContent = this.words.camera_ready; this.update();
      } catch {
        if (this.cameraRun !== run || this.dialog !== dialog) return;
        this.stopCamera(); this.status.textContent = this.words.camera_failed;
      }
    }
    beginCaptureCountdown() {
      if (!this.consented || !this.cameraActive || !this.cameraReady || this.capturing || this.credits?.remaining < 1) return;
      const run = this.cameraRun, dialog = this.dialog;
      this.capturing = true; let remaining = 3;
      const show = () => { this.countdown.textContent = String(remaining); this.cameraStatus.textContent = this.words.camera_countdown.replace('{seconds}', String(remaining)); };
      this.cameraPanel.classList.add('is-counting'); show(); this.update();
      this.cameraTimer = setInterval(() => {
        if (this.cameraRun !== run || this.dialog !== dialog || document.hidden) { this.stopCamera(); return; }
        remaining -= 1;
        if (remaining === 0) { clearInterval(this.cameraTimer); this.captureCamera(run, dialog); }
        else show();
      }, 1000);
    }
    async captureCamera(run,dialog) {
      if (this.cameraRun !== run || this.dialog !== dialog) return;
      try {
        const width = this.video.videoWidth, height = this.video.videoHeight;
        if (!width || !height || this.video.readyState < 2) throw new Error('camera');
        // Match the mirrored, centred 1:1 camera viewport in the saved photo.
        const cropWidth = Math.min(width,height), cropHeight = cropWidth;
        const canvas = document.createElement('canvas');
        canvas.width = canvas.height = Math.round(Math.min(896,cropWidth));
        const context = canvas.getContext('2d'); context.translate(canvas.width,0); context.scale(-1,1);
        context.drawImage(this.video,(width-cropWidth)/2,(height-cropHeight)/2,cropWidth,cropHeight,0,0,canvas.width,canvas.height);
        const blob = await new Promise(resolve => canvas.toBlob(resolve,'image/jpeg',0.9));
        if (this.cameraRun !== run || this.dialog !== dialog) return;
        if (!blob) throw new Error('camera');
        await this.selectPhoto(blob);
        if (this.dialog === dialog && this.photo) this.status.textContent = '';
      } catch {
        if (this.cameraRun === run && this.dialog === dialog) { this.stopCamera(); this.status.textContent = this.words.camera_failed; }
      }
    }
    syncNativeProduct() {
      if (!this.dialog) return;
      const form = document.getElementById(this.dataset.form), info = form?.closest('product-info');
      const selected = form?.querySelector('[name="id"]')?.value;
      if (selected && (!this.pendingVariant || selected === this.pendingVariant)) {
        const variant = this.variants.find(item => String(item.id) === String(selected));
        if (variant) {
          const completedSelection = Boolean(this.pendingVariant);
          const changed = String(this.variant?.id) !== String(variant.id);
          this.variant = variant; this.pendingVariant = null; clearTimeout(this.variantTimer);
          if (changed) this.step = this.resultVariant ? 'result' : this.photo ? 'review' : 'picture';
          if (completedSelection || changed) this.status.textContent = this.resultVariant === String(variant.id) ? '' : this.resultVariant ? this.words.colour_preview_needed : '';
          this.dialog.querySelector('[data-choice]').textContent = variant.title;
          const reference = this.dialog.querySelector('[data-product]');
          if (variant.featured_image?.src) { reference.src = variant.featured_image.src; reference.hidden = false; }
        }
      }
      const price = info?.querySelector('.price');
      const amount = price?.querySelector(price.classList.contains('price--on-sale') ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular');
      if (this.resultPrice && amount) this.resultPrice.textContent = amount.textContent.trim();
      this.dialog.querySelectorAll('[data-tryon-variant]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.tryonVariant === String(this.variant?.id)));
        button.disabled = this.busy || Boolean(this.pendingVariant);
      });
      this.update();
    }
    selectTryonVariant(id) {
      if (!this.dialog || this.busy || this.pendingVariant || String(this.variant?.id) === id) return;
      const variant = this.variants.find(item => String(item.id) === id);
      const picker = document.getElementById(this.dataset.form)?.closest('product-info')?.querySelector('variant-selects');
      if (!variant || !picker) { this.status.textContent = this.words.purchase_changed; return; }
      const groups = [...picker.querySelectorAll('fieldset, select')];
      const controls = variant.options.map((value, index) => groups[index]?.tagName === 'SELECT' ? groups[index] : [...(groups[index]?.querySelectorAll('input') || [])].find(input => input.value === value));
      if (controls.some(control => !control)) { this.status.textContent = this.words.purchase_changed; return; }
      this.pendingVariant = id; this.status.textContent = this.words.changing_colour;
      controls.forEach((control, index) => { if (control.tagName === 'SELECT') control.value = variant.options[index]; else control.checked = true; });
      this.update();
      controls.at(-1).dispatchEvent(new Event('change', {bubbles:true}));
      this.variantTimer = setTimeout(() => {
        if (!this.dialog || !this.pendingVariant) return;
        this.pendingVariant = null; this.syncNativeProduct(); this.status.textContent = this.words.purchase_changed;
      }, 10000);
    }
    async shareResult() {
      if (!this.dialog || this.busy || this.shareBusy || this.pendingVariant || !this.resultBlob || this.resultVariant !== String(this.variant?.id)) return;
      const dialog = this.dialog;
      this.shareBusy = true; this.update();
      const saveInstead = () => {
        if (this.dialog !== dialog) return;
        this.download.click(); this.status.textContent = this.words.share_fallback;
      };
      try {
        const file = new File([this.resultBlob], `ambreux-try-on.${this.resultBlob.type.split('/')[1]}`, {type:this.resultBlob.type});
        if (!navigator.share || !navigator.canShare?.({files:[file]})) { saveInstead(); return; }
        await navigator.share({files:[file], title:this.words.share_title});
      } catch (error) {
        if (error.name !== 'AbortError') saveInstead();
      } finally {
        if (this.dialog === dialog) { this.shareBusy = false; this.update(); }
      }
    }
    updateResultPurchase() {
      if (!this.buyButton) return null;
      const form = document.getElementById(this.dataset.form);
      const variant = form?.querySelector('[name="id"]');
      const submit = form?.querySelector('.product-form__submit');
      if (submit?.textContent.trim()) this.buyButton.textContent = submit.textContent.trim();
      const changed = String(variant?.value || '') !== this.resultVariant;
      const available = this.resultVariant && !changed && !this.pendingVariant && submit && !submit.disabled && submit.getAttribute('aria-disabled') !== 'true' && !variant.disabled;
      this.buyButton.disabled = !available || this.busy || this.purchaseStarted;
      this.purchaseStatus.textContent = changed ? (this.buyButton.hidden ? '' : this.words.purchase_changed) : !available ? this.words.purchase_unavailable : '';
      return available ? submit : null;
    }
    buyResult() {
      if (!this.dialog || !this.resultVariant || this.busy || this.purchaseStarted || this.pendingVariant) return;
      const submit = this.updateResultPurchase();
      if (!submit) return;
      this.purchaseStarted = true; this.buyButton.disabled = true;
      this.close();
      submit.click();
    }
    startGenerationAnimation() {
      this.stopGenerationAnimation();
      if (!this.generationOverlay) return;
      const started = performance.now();
      const renderTime = () => {
        const seconds = Math.max(0, Math.floor((performance.now() - started) / 1000));
        const time = `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
        this.generationTime.textContent = this.words.generation_elapsed.replace('{time}', time);
      };
      this.generationOverlay.hidden = false;
      if (this.generationPhoto && this.photoUrl) this.generationPhoto.src = this.photoUrl;
      if (this.uploadZone) this.uploadZone.hidden = true;
      this.dialog.classList?.add('at-generating');
      this.generationOverlay.focus?.({preventScroll:true});
      this.dialog.scrollTop = 0;
      renderTime();
      this.generationTimer = setInterval(renderTime, 1000);
    }
    stopGenerationAnimation() {
      clearInterval(this.generationTimer); this.generationTimer = null;
      const wasVisible = this.generationOverlay && !this.generationOverlay.hidden;
      if (this.generationOverlay) this.generationOverlay.hidden = true;
      this.generationPhoto?.removeAttribute('src');
      this.dialog?.classList?.remove('at-generating');
      if (wasVisible && this.uploadZone && !this.cameraActive) this.uploadZone.hidden = false;
    }
    async generate() {
      if (!this.consented || this.generateButton.disabled || this.creditExhausted || !this.credits || this.credits.remaining < 1) return;
      const dialog = this.dialog;
      const requestedVariant = this.variant.id;
      const visitorId = this.getVisitorId();
      this.busy = true; this.update(); this.status.textContent = this.words.generating;
      this.startGenerationAnimation();
      this.resultVariant = null;
      this.result.hidden = true; this.output.hidden = true; this.download.hidden = true; this.release('resultUrl');
      this.resultBlob = null;
      this.controller = new AbortController();
      const timer = setTimeout(() => this.controller?.abort(),100000);
      try {
        const body = new FormData();
        body.append('visitorId',visitorId); body.append('photo',this.photo,'photo.jpg'); body.append('handle',this.dataset.handle);
        body.append('variant',String(requestedVariant)); body.append('requestId',crypto.randomUUID()); body.append('consent','yes');
        const response = await fetch(new URL('/try-on',this.dataset.endpoint), {method:'POST',body,signal:this.controller.signal,credentials:'omit'});
        if (!response.ok) {
          const data = await response.json().catch(()=>({}));
          throw new Error(data.error === 'visitor_limit' ? 'limit' : ['daily_limit','unavailable'].includes(data.error) ? 'unavailable' : 'failed');
        }
        const blob = await response.blob();
        if (!['image/png','image/jpeg','image/webp'].includes(blob.type) || !blob.size || blob.size > 24*1024*1024) throw new Error('failed');
        const bitmap = await createImageBitmap(blob); bitmap.close();
        if (this.dialog !== dialog) return;
        this.resultUrl = URL.createObjectURL(blob); this.output.src = this.resultUrl; this.output.hidden = false; this.result.hidden = false;
        this.resultBlob = blob;
        this.resultVariant = String(requestedVariant);
        this.step = 'result';
        this.download.href = this.resultUrl; this.download.download = 'ambreux-try-on.'+blob.type.split('/')[1]; this.download.hidden = false;
        this.status.textContent = '';
      } catch (e) { if (this.dialog === dialog) this.status.textContent = this.words[e.message] || this.words.failed; }
      finally {
        clearTimeout(timer);
        if (this.dialog === dialog) {
          this.stopGenerationAnimation();
          this.busy = false;
          await this.checkCredits();
          if (this.dialog === dialog) { this.busy = false; this.update(); }
        }
      }
    }
  });
})();
